import React from "react";
import logo from "../../resources/images/logo_minigoal.png";

const Loading = () => (
  <div className="min-h-screen bg-white  grid place-content-center">
     <img src={logo} alt={'logo'} className={' m-auto w-1/4'}/>
  </div>
);

export default Loading;
